import config from 'config';
import { get } from 'lodash';
import { push, replace } from 'redux-little-router';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import storageItems from 'constants/storageItems';

import { routeMap } from 'router';
import Storage from 'services/Storage';
import { login } from '../../services/API';

import {
  actionTypes,
  ESAuthFailure,
  ESAuthSuccess,
  loginFailure,
  loginSuccess,
  startWorking,
  userCreated,
} from './actions';
import { ERROR_MESSAGES } from 'modules/Authorization/components/AuthorizationPage/private/ESAuth';

function* handleLogin(action) {
  const response = yield call(login, action.payload.data);

  if (response.isOk) {
    yield Storage.removeItem(storageItems.CODE_WORD_IS_DISABLED);
    yield put(
      loginSuccess({
        access_token: response.data.access_token,
        refresh_token: response.data.refresh_token,
      }),
    );
    yield put(startWorking());
  } else {
    yield put(replace(routeMap.login));
    yield put(loginFailure(response.error));
    yield Storage.removeItem(config.tokenItemName);
    yield Storage.removeItem(config.refreshTokenItemName);
  }
}

function* handleESLogin(action) {
  const response = yield call(login, action.payload.data, true);

  if (response.isOk) {
    const token = response.data.access_token;
    yield put(ESAuthSuccess(token));
    return true;
  }
  const errorId = get(response, 'error.response.data.error_description');
  const extMessage = get(response, 'error.response.data.extMessage');
  const errorMessage = extMessage || ERROR_MESSAGES[errorId] || ERROR_MESSAGES['OTHER_ERROR'];

  if (errorId === 'NEW_USER_CREATED') {
    yield put(userCreated());
  } else {
    yield put(ESAuthFailure(errorMessage, errorId));
    yield Storage.removeItem(config.tokenItemName);
  }
}

function* handleStartWorking() {
  const state = yield select();
  const { token, refresh_token, redirectUrl, userCreated } = state.authorization.login.toJS();
  if (userCreated) {
    yield put(
      replace({
        pathname: routeMap.info,
        query: {
          hasInn: 'true',
          fidProcessed: 'true',
        },
      }),
    );
  } else {
    yield put(push(redirectUrl));
    yield Storage.setItem(config.tokenItemName, token);
    if (refresh_token) {
      yield Storage.setItem(config.refreshTokenItemName, refresh_token);
    }
  }
}

function* handleESLoginWithEmail(action) {
  const success = yield handleESLogin(action);
  if (success) {
    yield handleStartWorking();
  }
}

export default function* userSaga() {
  yield takeLatest(actionTypes.REQUEST_START, handleLogin);
  yield takeLatest(actionTypes.ES_AUTH_CHECK, handleESLogin);
  yield takeLatest(actionTypes.ES_AUTH_WITH_EMAIL, handleESLoginWithEmail);
  yield takeLatest(actionTypes.START_WORKING, handleStartWorking);
}
